/*jslint node: true*/
"use strict";

var $ = require("pli/jquery");
var ko = require("pli/knockout");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Help functions for reporting criterias
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function computeLegalDescription() {
    /// <summary>
    /// Computes the label for the legal field based on
    /// NTS -> Units otherwise Sections
    ///
    /// Expects this to be legal Format value
    /// </summary>

    /*jshint validthis: true */
    switch (ko.utils.unwrapObservable(this)) {
    case "FREE":
        return "Enter any text";
    case "NTS":
        return "Example 94 A 12 H";
    case "PLSS":
        return "Example 5N 1W";
    default:
        return "Example 25 10 4";
    }
}


//-------------------------------------------
function getRawValuesFromMultiSelect() {
    /// <summary>
    /// Get items from MultiSelect selected by user(items and groups without replace),
    /// e.g. if selected "Us" it returns "Us"(instead of "PANDELL", "PANDELLSSH" )
    /// </summary>
    /// <remarks>
    /// Expects "this" to be ko.observable
    /// </remarks>

    /*jshint validthis: true */
    var v = this.multiSelectViewModel;
    if (v && ko.isObservable(v.selectedItems) && $.isArray(v.selectedItems())) {
        return ko.utils.arrayMap(v.selectedItems(), function (item) {
            return item.value;
        });
    }
}


//-------------------------------------------
function validateParametersFromUpcomingEvents(paramDate) {
    var dateFormatRegEx = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\-\d{4}$/i;

    return (dateFormatRegEx.test(paramDate));
}


//-------------------------------------------
function validateDateParam(paramDate) {
    var dateFormatRegEx = /^(Jan|January|Feb|February|Mar|March|Apr|April|May|Jun|June|Jul|July|Aug|August|Sep|September|Oct|October|Nov|November|Dec|December)(\-| )\d{4}$/i;

    return (dateFormatRegEx.test(paramDate));
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
if (!ko.reportUtils) { ko.reportUtils = {}; }

ko.reportUtils.computeLegalDescription = computeLegalDescription;
ko.reportUtils.getRawValuesFromMultiSelect = getRawValuesFromMultiSelect;
ko.reportUtils.validateParametersFromUpcomingEvents = validateParametersFromUpcomingEvents;
ko.reportUtils.validateDateParam = validateDateParam;

module.exports = ko;



//////////////////
// WEBPACK FOOTER
// ./app/report/reportExtensions.js
// module id = 510
// module chunks = 49